import { render, staticRenderFns } from "./taskJbDia.vue?vue&type=template&id=2b49f68a&scoped=true"
import script from "./taskJbDia.vue?vue&type=script&lang=js"
export * from "./taskJbDia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b49f68a",
  null
  
)

export default component.exports